import { ModuleRoutes } from '@kiplin/web-common/architecture-core';
import { loadLazyAppModuleGuard } from '@kiplin/web-common/dependency-injection';
import { LoginRouteName } from '@shared/feature/login/application/routes/login.route-name';
import { redirectIfAlreadyAuthenticated } from '@shared/feature/login/application/routes/redirect-if-already-authenticated.route-guard';
import type { Container } from 'inversify';
import type { RouteRecordRaw } from 'vue-router';

const LoginAppModule = () => import('@shared/feature/login/login.app-module');
const LoginPage = () => import('@shared/feature/login/application/page/LoginPage.vue');

export class LoginModuleRoutes extends ModuleRoutes<LoginRouteName> {
  constructor(container: Container) {
    const routes: RouteRecordRaw[] = [
      {
        path: '/login',
        name: LoginRouteName.Login,
        component: LoginPage,
        beforeEnter: [redirectIfAlreadyAuthenticated, loadLazyAppModuleGuard(LoginAppModule, container)],
      },
    ];

    super(routes);
  }
}
